import { useLocation } from "react-router";
import { FaGithub, FaInstagram, FaLinkedin, FaBars } from "react-icons/fa6";
import { useState } from "react";
import { CiMail } from "react-icons/ci";
import { FaYoutube } from "react-icons/fa";
export default function HomeNavigation() {
    const { pathname } = useLocation();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [showEmail, setShowEmail] = useState(false); // State to toggle email display

    const toggleEmailDisplay = () => {
        setShowEmail(!showEmail);
    };

    return (
        <>
            <div id="wd-rayan-navigation" className="p-4 rounded-0 position-relative d-none d-md-block">
                <div className="d-flex justify-content-between align-items-center">
                    <a
                        id="wd-rayan"
                        href="#/Rayan/Home"
                        className="text-light text-decoration-none"
                    >
                        <h1>Rayan Hassan</h1>
                    </a>

                    <ul className="nav align-items-center">
                        <li className="nav-item me-4">
                            <a
                                id="wd-home"
                                href="#/Rayan/Home"
                                className={`nav-link text-light ${
                                    pathname.includes("Home") ? "border-bottom rounded-0" : ""
                                }`}
                            >
                                Home
                            </a>
                        </li>
                        <li className="nav-item me-5">
                            <a
                                id="wd-about"
                                href="#/Rayan/About"
                                className={`nav-link text-light me-5 ${
                                    pathname.includes("About") ? "border-bottom rounded-0" : ""
                                }`}
                            >
                                About
                            </a>
                        </li>
                        <li className="nav-item me-4">
                            <a
                                href="https://github.com/rayoz6546/Rayan.git"
                                style={{ color: "white" }}
                            >
                                <FaGithub className="fs-3" />
                            </a>
                        </li>
                        <li className="nav-item me-4">
                            <a
                                href="https://www.linkedin.com/in/rayan-hassan-38a5b3226/"
                                style={{ color: "white" }}
                            >
                                <FaLinkedin className="fs-3" />
                            </a>
                        </li>

                        <li className="nav-item me-4">
                            <a
                                href="https://www.youtube.com/@rayanhassanDATASCIENCE"
                                style={{ color: "white" }}
                            >
                                <FaYoutube className="fs-3" />
                            </a>
                        </li>

                        <li className="nav-item me-4">
                            <button
                                onClick={toggleEmailDisplay}
                                style={{
                                    background: "none",
                                    border: "none",
                                    color: "white",
                                    cursor: "pointer",
                                }}
                            >
                                <CiMail className="fs-2" />
                            </button>
                        </li>
                    </ul>
                </div>

                {/* Email Tooltip */}
                {showEmail && (
                    <div
                        style={{
                            position: "absolute",
                            right: "20px",
                            top: "80px",
                            backgroundColor: "#0d9f7d",
                            color: "white",
                            padding: "10px 15px",
                            borderRadius: "5px",
                            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
                            zIndex: 1000,
                        }}
                    >
                        <p style={{ margin: 0, fontSize: "1rem" }}>
                        Work: <a className="text-light" href="mailto:hassan.ray@northeastern.edu">hassan.ray@northeastern.edu</a> <br />
                        Personal: <a className="text-light" href="mailto:rayanbassam.hassan@gmail.com">rayanbassam.hassan@gmail.com</a>
                        </p>
                    </div>
                )}
            </div>

            {/* Mobile Navigation */}
            <div id="mobile-navigation" className="d-md-none p-2">
                <div className="mobile-header d-flex justify-content-between align-items-center">
                    <h1 className="text-light">Rayan Hassan</h1>
                    <button
                        className="hamburger-menu"
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    >
                        <FaBars className="text-light fs-3" />
                    </button>
                </div>

                {isMobileMenuOpen && (
                    <ul className="mobile-nav mt-3">
                        <li className="nav-item">
                            <a
                                href="#/Rayan/Home"
                                className={`nav-link text-light ${
                                    pathname.includes("Home") ? "border-bottom rounded-0" : ""
                                }`}
                            >
                                Home
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                href="#/Rayan/About"
                                className={`nav-link text-light ${
                                    pathname.includes("About") ? "border-bottom rounded-0" : ""
                                }`}
                            >
                                About
                            </a>
                        </li>
  
                        <li className="nav-item d-flex gap-3">
                            <a href="https://github.com/rayoz6546/Rayan.git" className="text-light">
                                <FaGithub className="fs-3" />
                            </a>
                            <a
                                href="https://www.linkedin.com/in/rayan-hassan-38a5b3226/"
                                className="text-light"
                            >
                                <FaLinkedin className="fs-3" />
                            </a>
                            <a
                                href="https://www.youtube.com/@rayanhassanDATASCIENCE"
                                style={{ color: "white" }}
                            >
                                <FaYoutube className="fs-3" />
                            </a>

                            <button
                                onClick={toggleEmailDisplay}
                                style={{
                                    background: "none",
                                    border: "none",
                                    color: "white",
                                    cursor: "pointer",
                                }}
                            >
                                <CiMail className="fs-2" />
                            </button>


                        </li>
                        {showEmail && (
                            <li className="nav-item">
                                <p style={{ color: "white", fontSize: "1rem" }}>
                                    Work: <a className="text-light" href="mailto:hassan.ray@northeastern.edu">hassan.ray@northeastern.edu</a><br />
                                    Personal: <a className="text-light" href="mailto:rayanbassam.hassan@gmail.com">rayanbassam.hassan@gmail.com</a>
                                </p>
                            </li>
                        )}
                    </ul>
                )}
            </div>
        </>
    );
}
